
  export const filesExtToContentTypes = (fileName) => {
    let extToContentTypes = {
        "csv" : "text/csv",
        "txt" : "text/plain",
        "doc" : "application/msword",
        "dot" : "application/msword", 
        "docx" : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "pdf" : "application/pdf",
        "xls" : "application/vnd.ms-excel",
        "xlsx" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "jpg": "image/jpeg",
        "jpeg": "image/jpeg",
        "png": "image/png"
    };
  
    let fileExt = fileName.substring(fileName.lastIndexOf('.')+1);
  
    return extToContentTypes[fileExt] ? extToContentTypes[fileExt.toLowerCase()] : null;
  }